import * as React from 'react';
import { Tag as BaseTag } from '@mc/react-core';
import classNames from 'classnames';

type Props = Omit<
  React.ComponentProps<typeof BaseTag>,
  'intent' | 'multiline' | 'minimal' | 'fill' | 'round' | 'rightIcon'
>;

const ClassNameNS = 'app-tag';
const ClassName = ` ${ClassNameNS}`;

/**
 * Tag element
 * Pro např.: zobrazení čísla u napisů, zvýraznění počtu hodnot etc...
 *
 * <pre>
 * TODO - Nutno dořešit prosy
 *  - icon ? -> lze použít children
 *  - active ?
 *  - rightIcon ?
 * </pre>
 */
export class Tag extends React.PureComponent<Props> {
  render() {
    const { className, ...other } = this.props;
    return (
      <BaseTag
        {...other}
        className={classNames(ClassName, className, [`${ClassNameNS}-fw`])}
      />
    );
  }
}
